// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"ae36016f","622":"82879d70","633":"b8a9a2f5","787":"1d51f90b"}[chunkId] + ".chunk.js";
};